import React from 'react'
import {Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch} from 'react-hook-form'
import {MonthYearInput} from '../../../../common/component/MonthYearInput'
import {MobileNumberInput} from '../../../../common/component/MobileNumberInput'
import {SelectInput} from '../../../../common/component/SelectInput'
import {TextInput} from '../../../../common/component/TextInput'
import {IApplicationFormData} from '../../../models/application-form'
import {employmentPath} from './employmentPath'

interface EmploymentDetailsSectionProps {
  register: UseFormRegister<IApplicationFormData>
  control: Control<IApplicationFormData>
  errors?: FieldErrors<IApplicationFormData>
  watch: UseFormWatch<IApplicationFormData>
  setValue: UseFormSetValue<IApplicationFormData>
}

const employmentTypeOptions = [
  {label: 'Full-time', value: 'full-time'},
  {label: 'Part-time', value: 'part-time'},
  {label: 'Casual', value: 'casual'},
  {label: 'Fixed-term contract', value: 'fixed-term contract'},
  {label: 'Apprentice / Trainee', value: 'apprentice / trainee'},
  /*{label: 'Contract', value: 'contract'},
  {label: 'Self-employed', value: 'self-employed'},
  {label: 'Student', value: 'student'},
  {label: 'Unemployed', value: 'unemployed'},
  {label: 'Retired', value: 'retired'},
  {label: 'Other', value: 'Other'},*/
]

const EmploymentDetailsSection: React.FC<EmploymentDetailsSectionProps> = ({
  register,
  control,
  errors,
  watch,
  setValue,
}) => {
  const employmentType = watch(employmentPath('employmentType'))
  const showSelfEmployed = employmentType === 'self-employed'

  return (
    <>
      <div>
        <TextInput
          name={employmentPath('companyName')}
          label='Where do you work?'
          placeholder='Company name'
          register={register}
          errors={errors}
          className='mt-5'
          required={true}
        />
        <SelectInput
          name={employmentPath('employmentType')}
          label='Employment Type'
          register={register}
          errors={errors}
          optionsList={employmentTypeOptions}
          required={true}
        />
        <MonthYearInput
          name={employmentPath('startDate')}
          monthUnknownName={employmentPath('isStartMonthUnknown')}
          label='When did you start'
          helperText='Approx is fine — Agents only need an idea on your tenure.'
          control={control}
          errors={errors}
          className='mt-5'
          required={true}
        />
        <hr className='mt-5 mb-4 text-muted'></hr>
        <div className='mb-5'>
          <h5 className='subheader'>WORK REFERENCE</h5>
          <span className='secondary text-muted'>Used to verify your work</span>
        </div>

        <TextInput
          name={employmentPath('additionalReferenceName')}
          label="Reference's full name"
          placeholder='Full name'
          register={register}
          errors={errors}
          required={true}
        />

        <MobileNumberInput
          name={employmentPath('additionalReferencePhone')}
          label='Their phone'
          placeholder='0400 000 000'
          control={control}
          errors={errors}
          required
          className='wizard-start-field'
          inputClassName='wizard-start-input'
        />
        <TextInput
          name={employmentPath('additionalReferenceEmail')}
          label='Their email'
          placeholder='name@company.com'
          register={register}
          errors={errors}
          required
        />
      </div>
    </>
  )
}

export default EmploymentDetailsSection
